import { IconButton } from './IconButton';
import { classNames } from '~/utils/classNames';

interface PaginationProps {
  className?: string;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination = ({ className, page, totalPages, onPageChange }: PaginationProps) => {
  return (
    <div
      className={classNames(
        'flex items-center gap-2 w-full justify-between border border-bolt-ds-border-divider rounded-lg p-2',
        className,
      )}
    >
      <IconButton
        size="sm"
        variant="ghost"
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        className="transition-colors"
        icon="i-heroicons:arrow-left-solid"
      />
      <span className="min-w-15 px-1 flex items-center justify-center gap-1 text-sm text-bolt-ds-textSecondary">
        Page {page} of {totalPages}
      </span>
      <IconButton
        size="sm"
        variant="ghost"
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        className="transition-colors"
        icon="i-heroicons:arrow-right-solid"
      />
    </div>
  );
};
